import React from 'react';
import styled from '@emotion/styled';
import {FloatingPortal} from '@floating-ui/react';

import theme from 'theme';

import {useDropdown} from './hook';

import type {CSSProperties} from 'react';
import type {DropdownProps} from './types';

const containerStyle = (props: DropdownProps, acc: CSSProperties) => {
  const {isOpen, height, maxHeight, zIndex = theme.zIndex.dropdown, width = '248px'} = props;

  if (isOpen) {
    return {
      zIndex,
      height,
      maxHeight,
      width: width !== 'target' ? width : undefined,

      ...acc,
    };
  }

  return {
    display: 'none',

    ...acc,
  };
};

export const DropdownContent = styled.div`
  height: 100%;
  border-radius: 8px;
  box-shadow: ${theme.shadows.medium};
  background-color: ${theme.colors.white};
`;

export const Dropdown: React.FC<DropdownProps> = props => {
  const {children, isPortal, isMounted, isOpen, className, qa = 'dropdown'} = props;

  const {interactions, floating} = useDropdown(props);

  if (!isMounted && !isOpen) {
    return null;
  }

  const Wrapper = isPortal ? FloatingPortal : React.Fragment;

  const containerProps = {
    ...interactions.getFloatingProps(),

    children,
    className,

    style: containerStyle(props, floating.floatingStyles),

    'data-qa': qa,
  };

  return (
    <Wrapper>
      <div ref={floating.refs.setFloating} {...containerProps} />
    </Wrapper>
  );
};
